<template>
  <div class="animated fadeIn">
    <Loader :is-visible="loading" />

    <StatsMarginRateFilters @apply="applyFilters" />

    <div class="card">
      <div class="card-header">
        <i class="fa fa-bar-chart-o"></i> Taux de marge
        <el-popover placement="top" trigger="hover">
          <template #default>
            <p>
              Afin d’avoir des chiffres calés sur la méthode comptable retrouvée
              dans les échanges avec le cabinet comptable,<br />
              le taux de marge brut est calculé à partir des données suivantes
              :<br />
              - Prix moyen / séance en HT<br />
              - Taux horaire coach moyen en HT<br />
            </p>
          </template>

          <template #reference>
            <i class="fa fa-info-circle"></i>
          </template>
        </el-popover>
      </div>

      <div class="card-block">
        <div v-if="!stats" class="text-center text-muted">
          Sélectionnez des filtres, puis cliquez sur "Visualiser"
        </div>

        <div v-else class="row">
          <StatsMarginRateCard isSuccess>
            <template #title> Taux de marge </template>

            <template> {{ stats.marginRate }} % </template>
          </StatsMarginRateCard>

          <StatsMarginRateCard>
            <template #title>Prix moyen / séance</template>

            <template
              >{{ stats.averageSessionPrice }} € HT<br />
              <span class="font-weight-normal"
                >({{ priceIncludingTax(stats.averageSessionPrice) }} €
                TTC)</span
              ></template
            >
          </StatsMarginRateCard>

          <StatsMarginRateCard>
            <template #title>Taux horaire coach moyen</template>

            <template
              >{{ stats.averageCoachCredit }} € HT<br />
              <span class="font-weight-normal"
                >( {{ stats.ratioAverageCoachCreditAverageSessionPrice }} % du
                prix moyen / séance)</span
              ></template
            >
          </StatsMarginRateCard>

          <StatsMarginRateCard>
            <template #title>Nombre de séances</template>

            <template>{{ stats.totalSessions }}</template>
          </StatsMarginRateCard>

          <StatsMarginRateCard>
            <template #title>Prix total (séances)</template>

            <template>{{ stats.totalPrice }} €</template>
          </StatsMarginRateCard>

          <StatsMarginRateCard>
            <template #title>Coût total (coachs)</template>

            <template>{{ stats.totalCredit }} €</template>
          </StatsMarginRateCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/utils/Loader";
import StatsMarginRateCard from "@/components/stats/StatsMarginRateCard";
import StatsMarginRateFilters from "@/components/stats/StatsMarginRateFilters";

export default {
  components: {
    Loader,
    StatsMarginRateFilters,
    StatsMarginRateCard,
  },

  data() {
    return {
      loading: false,
      stats: null,
      filters: {
        begin: null,
        end: null,
        type: null,
        concepts: [],
        merchants: [],
        commercials: [],
      },
    };
  },

  methods: {
    async loadStats() {
      try {
        this.loading = true;
        const { data } = await this.$api.get("/stats/margin-rate", {
          params: this.filters,
        });

        this.stats = data;
      } catch (e) {
        this.$errorToast("Impossible de charger cette statistique");
      } finally {
        this.loading = false;
      }
    },

    applyFilters(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };

      this.loadStats();
    },

    priceIncludingTax(price) {
      return (price * 1.2).toFixed(2);
    },
  },
};
</script>
